import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import BackendApi from '../BackendApi';
import CookieStor from '../CookieStor'
import Header from '../components/Header';
import VideoList from '../components/VideoList';


class Main extends Component {

  constructor(props){
    super(props);

    this.state = {
      items: '',
      imageList: '',
      pagination: '',
      currentPage: 1
    };
  }

  componentDidMount(){
		this.pageRequest()
  }

  pageRequest = (page) => {
    BackendApi.videoList(page || this.state.currentPage).then((result) => {
		  switch(result.status)
        {
          case 200:
            this.setState({
              items: Array.isArray(result.data) ? result.data:[],
              pagination: result.pagination ? result.pagination:{},
            });
            this.getImage(Array.isArray(result.data) ? result.data:[])
            break;
          
          case 401:
            CookieStor.setAccessToken('');
            CookieStor.setRefreshToken('');
            this.props.history.push('/');
            break;
          
          default:
            console.log('Ошибка сервера')
        }
    })
  }

  getImage = (cardList) => {
    let imageList = [];
    for(var key in cardList){
      imageList.push(cardList[key].preview_image + '?access-token=' + CookieStor.getAccessToken())
    }
    this.setState({imageList: imageList});
  }
  
  paginationChange = (page) => {
    this.setState({currentPage: page});
    this.pageRequest(page)
  }

  render() {
    if (!CookieStor.getAccessToken()) {
      return <Redirect to='/'/>
    }
    return (
      <div className='page'>
        <Header/>
        <VideoList cardList={this.state.items} imageList={this.state.imageList} pagination={this.state.pagination} paginationChange={this.paginationChange}/>
      </div>
    );
  }
}

export default Main;
